import React, { useState, useEffect } from "react";
import { Divider, Skeleton, Space, Row, Col } from "antd";
import { gql, useLazyQuery } from "@apollo/client";
import moment from "moment-jalaali";


const GETTRANSACTION = gql`
  query ($id: ID!) {
    getPurchase(id: $id) {
      createdAt
      user {
       name
       mobile
      }
      purchaseType
      amount
      description
    }
  }
`;

function PurchasesTableDetails({ id }) {
  const [initialData, setInitialData] = useState({});

  const [getPurchaselData, purchaseData] = useLazyQuery(GETTRANSACTION, {
    fetchPolicy: "no-cache",
    onCompleted({ getPurchase }) {
      const { description, user, createdAt, amount, purchaseType } = getPurchase;
      setInitialData({
        description,
        purchaseType,
        user,
        amount,
        createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
      });
    },
  });
  useEffect(() => {
    if (id) {
      getPurchaselData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  const { user, createdAt, description, purchaseType, amount } = initialData;
  const purchaseTypeHandler = () => {
    if (purchaseType === "CARD") return "فروش کارت";
    if (purchaseType === "PRODUCT") return "فروش خدمات";
    if (purchaseType === " HOLIDAY") return "روز تعطیل";
    if (!purchaseType) return "نامشخص";
  };

  if (purchaseData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );

  return (
    <>

      <Divider style={{ fontWeight: 700 }} orientation="right">
        اطلاعات درآمد
      </Divider>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>تاریخ ثبت: </p>
            {createdAt}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>دسته بندی: </p>
            {purchaseTypeHandler()}
          </Space>
        </Col>
      </Row>
      <Row gutter={30}>
        <Col sm={12} xs={24}>
          <Space align="">
            <p style={{ fontWeight: "bold" }}>مبلغ: </p>
            {amount?.toLocaleString()} <p>ریال</p>
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p style={{ fontWeight: "bold" }}>پرداخت کننده: </p>
            {user?.name || user?.name || user?.mobile || 'نامشخص'}
          </Space>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
        <p style={{ fontWeight: "bold" }}>توضیحات: </p>
        {description}
        </Col>
      </Row>
    </>
  );
}

export default PurchasesTableDetails;
